<template>
  <div>
    <Button
      :size="15"
      color="#2c7bcd"
      colorText="#ffffff"
      tooltip="Editar Multiples Seleccionados"
      icon="fas fa-edit"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      translate
      @click.native="showEditMultiple();"
    />
    <ui-modal
      ref="modal"
      title="Editar Múltiples Acuerdos de Líneas"
      class="modal-editar-simple-acuerdo-linea"
      size="auto"
      @close="ActionSetZindexModal(false)"
    >
      <div class="w-100" id="editarMultipleAcuerdoLineasModal">
        <data-table-acuerdos-lineas
          :headers="headers"
          :data="dataAux"
          idtabla="listado_confirmar_seleccionados1"
          :formulario="true"
          :acciones="[]"
          :load="load"
          :filtroContenedores="filtroContenedores"
          :filtroCommodity="filtroCommodity"
          :filtroAtmosferas="filtroAtmosferas"
          :filtroColdtreatment="filtroColdtreatment"
        />
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-2">
        <button class="btn btn-default" @click="closeModal('modal'), ActionSetZindexModal(false)">
          Cerrar
        </button>
        <button class="btn btn-outline-warning" @click="validarFormulario" id="buttonRef1">
          Actualizar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";
// Vuex
import { mapState, mapActions } from "vuex";
// Toast
import VueToastify from "vue-toastify";
// Common
import Button from "../../../../common/Button";
import DataTableAcuerdosLineas from "../../../../dataTables/tarifas/DataTableAcuerdosLineas";
import {
  listarAcuerdosLineasByIds,
  updateAcuerdoLineas,
  getListasAcuerdosBase
} from "@/constants/lineas";
Vue.use(VueToastify);

export default {
  props: ["acuerdoLineaArreglo", "idContrato", "dataPrueba", "getListaAcuerdosLineas","vaciarAcuerdoLineas"],
  data() {
    return {
      dataAux: [],
      load : false ,
      headers:[
        { title: "N°", width: "10px" },
        { title: "Naviera", width: "30px" },
        { title: "Naviera Salida", width: "30px" },
        { title: "POL", width: "30px" },
        { title: "POD", width: "30px" },
        { title: "Desde", width: "50px" },
        { title: "Hasta", width: "50px" },
        { title: "TT", width: "40px" },
        { title: "Neta (Costo)", width: "50px" },
        { title: "Pública (Venta)", width: "50px" },
        { title: "Descuento", width: "10px" },
        { title: "Unidad", width: "10px" },
        { title: "Commodity", width: "50px" },
        { title: "Atmósfera", width: "30px" },
        { title: "Trat. frío", width: "30px" },
        { title: "FDO", width: "10px" },
        { title: "PDO", width: "10px" },
        { title: "FDD", width: "10px" },
        { title: "PDD", width: "10px" },
        { title: "Genset", width: "2px" },
        { title: "Get Out", width: "2px" },
        { title: "Comentarios", width: "20px" },
        { title: "Tipo Contrato", width: "70px" },
        { title: "Contrato - Número", width: "70px" },
      ],
      filtroContenedores: [],
      filtroCommodity: [],
      filtroAtmosferas: [],
      filtroColdtreatment: [],
      navieras_no_ucc: []
    };
  },

  components: {
    Button,
    DataTableAcuerdosLineas
  },
  computed: {
    ...mapState("lineas", ["dataListaNaviera", "dataListaNavierasNoUCC", "dataListaPOD", "dataListaPOL", "selectAtmospheres"]),
    ...mapState(["puertos"]),
  },
  methods: {
    ...mapActions(["ActionSetZindexModal"]),
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRef1");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    async loadData() {
      let dataListas = await getListasAcuerdosBase();
      this.filtroContenedores = dataListas.filtro_contenedores;
      this.filtroCommodity    = dataListas.lista_prod_categories;
      this.filtroAtmosferas   = dataListas.lista_atmosferas;
      this.filtroColdtreatment = dataListas.lista_coldtreatment || [];
    },
    async showEditMultiple() {

      if (this.acuerdoLineaArreglo.length === 0) {

        return this.$vToastify.warning(
          "Debe seleccionar Acuerdos de Líneas para editar.",
          "!Precaución¡"
        );

      }

      this.load = true;

      this.openModal("modal");

      await this.loadData();

      const data = await listarAcuerdosLineasByIds({ ids: this.acuerdoLineaArreglo });

      this.dataAux = data.map(al => (
          {
            id: al.id,
            naviera: { id: al.naviera_id, name: al.naviera },
            naviera_salida: { id: al.naviera_salida_id, name: al.naviera_salida },
            pol: { id: parseInt(al.pol_id), name: al.pol },
            pod: { id: parseInt(al.pod_id), name: al.pod },
            from_date: al.from_date,
            to_date: al.to_date,
            transit_time: al.transit_time,
            neta: al.neta,
            public_value: al.public_value,
            container_id: { id: al.container_id, code: al.unidad, ac: al.container_ac },
            products_category_id: { id: al.product_container_id, name: al.commodity },
            descuento: parseInt(al.public_value) - parseInt(al.neta),
            atmosphere_id: { id: al.atmosphere_id, name: al.atmosfera },
            coldtreatment: al.coldtreatment && al.coldtreatment !== "-" ? {
              id: al.coldtreatment_id || "",
              name: al.coldtreatment,
            } : {
              id: "",
              name: "",
            },
            free_days_embark: al.free_days_embark,
            plug_days_embark: al.plug_days_embark,
            free_days_land: al.free_days_land,
            plug_days_land: al.plug_days_land,
            genset: al.genset === "Si",
            get_out: al.get_out === "Si",
            comment: al.comment,
            tipo_contrato_id: { id: +al.tipo_contrato_id, name: al.tipo_contrato },
            tariff_contract_id: { id: +al.tariff_contract_id, name: al.contratoynumero },
            contract: al.contratoynumero,
            contractsList: [],
            navieras_salida_list: al.naviera === "UCC" ? this.dataListaNavierasNoUCC : [{
              id: al.naviera_id,
              name: al.naviera
            }],
            atmospheres_list: al.container_ac === 0 ? this.selectAtmospheres.filter(item => item.id === 13) : this.selectAtmospheres.filter(item => item.id !== 13)

          }
        )
      );

      this.load = false;
    },
    async validarFormulario() {

      const  form = this.ordenarData();

      let valid = true ;

      for (let tariff_lines of form.tariff_lines) {

        if (tariff_lines.naviera_id === "" || tariff_lines.naviera_id === undefined ) {
          this.$vToastify.error("Campo Naviera vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if (tariff_lines.naviera_salida_id === "" || tariff_lines.naviera_salida_id === undefined ) {
          this.$vToastify.error("Campo Naviera Salida vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if (tariff_lines.pol === "" || tariff_lines.pol === undefined ) {
          this.$vToastify.error("Campo POL vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if (tariff_lines.pod === "" || tariff_lines.pod === undefined ) {
          this.$vToastify.error("Campo POD vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if (tariff_lines.from_date === "" || tariff_lines.from_date === undefined ) {
          this.$vToastify.error("Campo DESDE vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if (tariff_lines.to_date === "" || tariff_lines.to_date === undefined ) {
          this.$vToastify.error("Campo HASTA vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if (tariff_lines.transit_time === "" || tariff_lines.transit_time === undefined ) {
          this.$vToastify.error("Campo TT vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if (tariff_lines.neta === "" || tariff_lines.neta === undefined ) {
          this.$vToastify.error("Campo Neta (Costo) vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.public_value === "" || tariff_lines.public_value === undefined ) {
          this.$vToastify.error("Campo Pública (Venta) vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.container_id === "" || tariff_lines.container_id === undefined ) {
          this.$vToastify.error("Campo Unidad vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.products_category_id === "" || tariff_lines.products_category_id === undefined ) {
          this.$vToastify.error("Campo Commodity vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.atmosphere_id === "" || tariff_lines.atmosphere_id === undefined ) {
          this.$vToastify.error("Campo Atmósfera vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.free_days_embark === "" || tariff_lines.free_days_embark === undefined ) {
          this.$vToastify.error("Campo Free Days Origen vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.plug_days_embark === "" || tariff_lines.plug_days_embark === undefined ) {
          this.$vToastify.error("Campo Plug Days Origen vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.free_days_land === "" || tariff_lines.free_days_land === undefined ) {
          this.$vToastify.error("Campo Free Days Destino vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.plug_days_land === "" || tariff_lines.plug_days_land === undefined ) {
          this.$vToastify.error("Campo Plug Days Destino vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.tipo_contrato === "" || tariff_lines.tipo_contrato === undefined ) {
          this.$vToastify.error("Campo Tipo Contrato vacío", "¡Error!");
          valid = false ;
          break ;
        }

      }

      if( !valid ) return ;
      try {
      this.estadoButton("Actualizando...");
      this.$vToastify.loader("Actualizando Acuerdo de Líneas...");

        const { error } = await updateAcuerdoLineas( form );
        this.$vToastify.stopLoader();

        this.estadoButton("Actualizar", false);
        if( error ){
          this.$vToastify.error("Error al actualizar campos, intente más tarde.", "¡Error!");
          return ;
        }

        this.getListaAcuerdosLineas() ;

        this.closeModal('modal') ;
        this.$vToastify.success("Acuerdos Lineas Actualizado Correctamente!","Solicitud realizada");
      } catch (error) {
        this.estadoButton("Actualizar", false);
        this.$vToastify.stopLoader();
        this.$vToastify.error("Error al actualizar campos, intente más tarde.", "¡Error!");

      }
    },
    cambiaValorDescuento: function () {
      const descuento = parseInt(this.form.public_value.value) - parseInt(this.form.neta.value);
      this.discount = descuento < 0 ? 0 : descuento;
    },
    ordenarData() {
      return {
        tariff_lines : this.dataAux.map( al => ({
          id : al.id ,
          naviera_id : +al.naviera.id ,
          naviera_salida_id : +al.naviera_salida.id ,
          pol : al.pol.id ,
          pod : al.pod.id ,
          atmosphere_id : al.atmosphere_id.id,
          coldtreatment :
            typeof al.coldtreatment === "object"
              ? (al.coldtreatment.name || "")
              : (al.coldtreatment || ""),
          container_id : al.container_id.id ,
          products_category_id : al.products_category_id.id ,
          public_value : al.public_value,
          from_date :  al.from_date ,
          to_date :  al.to_date ,
          transit_time :  al.transit_time ,
          neta : al.neta ,
          contract : al.contract,
          free_days_embark: al.free_days_embark,
          plug_days_embark: al.plug_days_embark,
          free_days_land: al.free_days_land,
          plug_days_land: al.plug_days_land,
          genset: al.genset,
          get_out: al.get_out,
          tipo_contrato: al.tipo_contrato_id.id,
          tariff_contract_id: al.tariff_contract_id.id,
          comment: al.comment
        }))
      };
    },
    openModal(ref) {
      this.ActionSetZindexModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    cerrarModal() {
      this.ActionSetZindexModal(false);
    },
  },

};
</script>

<style >
body #editarMultipleAcuerdoLineasModal .mx-datepicker {
  margin-left: 0px !important;
}
</style>
